import { inject, observer } from "mobx-react"
import { useStores } from "hooks/useStores"

import type _User from 'mobx/User'
import type _Infra from 'mobx/Infra'

import { codeToLocale, getLocaleStr, getTranslatedTextByKey } from 'utils/utils'

import { 
    IconContainer, EditIcon, DeliveryIcon, PickupIcon, LocalizedContent as StyledLocalizedContent, 
    LocalizedLeftContent, LocalizedLeftTextContainer, LocalizedLeftTextLine, LocalizedTextLabel, LocalizedLeftText 
} from './style'

const LocalizedContent = inject(
	'User',
    'Infra'
)(
    observer(({ User, Infra, displayOrderTypeIcon = true }: {User: typeof _User, Infra: typeof _Infra, displayOrderTypeIcon: boolean}) => {
        const { localizationStore } = useStores()
        const preferredLanguage = User?.preferredLanguage || 'en'
        const langFromInfra = Infra?.appParams?.l || 'en'
        const locale = User?.preferredLanguage ? codeToLocale[preferredLanguage] : codeToLocale[langFromInfra]

        return (
            <StyledLocalizedContent onClick={localizationStore.edit}>
                <LocalizedLeftContent>
                    {displayOrderTypeIcon && 
                        <IconContainer>
                            {localizationStore.actualFlow?.orderTypeFlow?.requireAddress ? <DeliveryIcon /> : <PickupIcon />}
                        </IconContainer>
                    }
                    <LocalizedLeftTextContainer>
                        <LocalizedLeftTextLine>
                            <LocalizedTextLabel variant="BodySmallHighlighted">
                                {localizationStore.actualFlow?.orderTypeFlow && getTranslatedTextByKey(localizationStore.actualFlow.orderTypeFlow.orderTypeTranslationKey, localizationStore.actualFlow?.orderTypeFlow?.orderType)}
                                {" "}
                                {getTranslatedTextByKey('from', 'from')}: 
                            </LocalizedTextLabel>
                            <LocalizedLeftText variant="BodySmall">
                                {localizationStore?.actualFlow?.store && getLocaleStr(localizationStore.actualFlow.store.name, locale)}
                            </LocalizedLeftText>
                        </LocalizedLeftTextLine>
                    
                        <LocalizedLeftTextLine>
                            <LocalizedTextLabel variant="BodySmallHighlighted">
                                {localizationStore.actualFlow?.orderTypeFlow?.requireAddress ? getTranslatedTextByKey('to', 'To') : getTranslatedTextByKey('storeAddress', 'Store Address')}:
                            </LocalizedTextLabel>
                            <LocalizedLeftText variant="BodySmall">
                                {localizationStore.actualFlow?.address && localizationStore.actualFlow.address.formatted!}
                            </LocalizedLeftText>
                        </LocalizedLeftTextLine>
                    </LocalizedLeftTextContainer>
                </LocalizedLeftContent>
                <IconContainer>
                    <EditIcon />
                </IconContainer>
            </StyledLocalizedContent>
        )
    }
))

export default LocalizedContent